/**
 * Initialize search form functionality
 */
export function initSearchForm() {
	// Clean up empty keyword parameter before htmx submits
	document.addEventListener("htmx:config:request", function (evt) {
		if (evt.detail.elt && evt.detail.elt.classList.contains("search-form")) {
			const keyword = evt.detail.ctx.request.parameters.keyword;
			if (!keyword || keyword.trim() === "") {
				delete evt.detail.ctx.request.parameters.keyword;
			} else {
				evt.detail.ctx.request.parameters.keyword = keyword.trim();
			}
		}
	});
}
